import { Entity } from '@/store/shared/entity'
import DeclareGroup from '../declaregroup/entity';
import customsBox from './customsbox';
import DeclareProductList from '../declareproductlist/entity'

export default class DeclareCustoms extends Entity<number>{
  
        shippingNumber:string;        
      
        businessGroup:string;        
 
        shipmentDate:Date;        
   
        senderId:number;        
        //??ID
        customerId:number;        
        //????
        customerName:string;        
        //???
        receiver:string;        
        //
        payment:string;        
        //????
        isAdvance:boolean;        
        //?????
        receiverAddress:string;        
        //????
        shippingType:string;        
        //????
        deal:string;        
        //???
        startPort:string;        
        //???
        endtPort:string;        
        //???
        countryOfArrival:string;        
        //???
        tradingCountry:string;        
        //??
        shippingMark:string;        
        //
        totalVolume:number;        
        //
        boxUnit:string;        
        //????
        receiverAmount:number;        
        //?????
        domesticSourceOfGood:string;        
        //????
        packingType:string;        
        //???????
        remark:string;        
        //??????
        isShowNetWeight:boolean;        
     
        currency:string;        
      
        salesType:string;    
        status:string;        
      
        ownerId:number;  
        
        itemNumber:number; 
        isComPdf:boolean;
        isCanModify:boolean;
        isofficialSeal:string;   
        formType:string;   
        // 清单
        declareGroupList: Array<DeclareGroup>;

        customsBoxList:Array<customsBox> = new Array<customsBox>();

        declareProductList: Array<DeclareProductList>=new Array<DeclareProductList>();
        
        customerConfirmStatus:string;
        isOtherInfo:boolean;
        isUploadedBillOfLading:boolean;
        regulatoryApproach:string;
        accompanyingDocuments:string;
        createType:number;
        copySourceId:number;

        constructor() {
                super();
                this.declareGroupList = new Array<DeclareGroup>();
        }
}

